export function about() {
    const $window = $(window);

    function animationOnScroll() {
        let $items = $(".has-animation");

        $items.each(function (i, it) {
            if ($window.scrollTop() > $(it).offset().top - $window.height() * 0.88 && !$(it).hasClass("animate")) {
                $(it).addClass("animate");
            }
        });
    }

    function accusationLoadMore() {
        $('.load-more-holder .button').on('click', function (e) {
            e.preventDefault();

            let _this = $(this);
            let data = {
                'action': 'accusation_load_more',
                'post_id': _this.attr('data-post-id'),
                'offset': _this.attr('data-offset'),
                'total': _this.attr('data-total'),
                'nonce': _this.attr('data-field-nonce')
            };

            $.ajax({
                url: ajaxvars.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function () {
                    _this.addClass('active');
                },
                success: function (response) {
                    $('.history-line').append(response.content);
                    _this.attr('data-offset', response.offset);

                    if (!response.more) {
                        $('.load-more-holder').hide();
                    }

                    animationOnScroll();
                },
                complete: function () {
                    _this.removeClass('active');
                }
            });

            return false;
        });
    }

    $window.on("load", function () {
        accusationLoadMore();
    });
    $window.on("scroll load", function () {
        animationOnScroll();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/about.js